<nav>
	<!-- Rule Name - Group Name -->
	<div class="panel panel-default rules-nav">
		<div class="panel-heading">
			<input type="text" [(ngModel)]="mRule.name" class="form-control input-lg" placeholder="RULE NAME" autofocus />
			<input type="text" [(ngModel)]="mRule.group" class="form-control" placeholder="GROUP NAME" autocomplete="off" />
		</div>
		<div class="panel-body rules-nav-body">
			<ul class="list-group">

				<!-- STEP 1 - SELECT THE TRIGGER -->
				<li class="list-group-item rule-item" [class.active]="mStep == mSteps.S1_SELECT_TRIGGER" (click)="stepSelected.emit(mSteps.S1_SELECT_TRIGGER)">
					<h4><em class="fa fa-bolt" aria-hidden="true"></em> TRIGGER</h4>
					<p>{{mRule.event?.name}}</p>
				</li>
						
				<!-- STEP 2 - SET UP PARAMETERS -->
				<li class="list-group-item rule-item" [class.active]="mStep == mSteps.S2_SET_UP_PARAMETERS" (click)="stepSelected.emit(mSteps.S2_SET_UP_PARAMETERS)">
					<h4><em class="fa fa-cogs" aria-hidden="true"></em> PARAMETERS</h4>
					<span *ngIf="mRule.conditions != null">
						<ng-container *ngFor="let condition of mRule.conditions">
							<span *ngIf="condition.sourceType == mSourceTypes.EVENT">
								<p>{{getLabelForEventParameter(condition.source)}}</p>
							</span>
						</ng-container>
					</span>
				</li>
						
				<!-- STEP 3 - ADD FILTER(S) -->
				<li class="list-group-item rule-item" [class.active]="mStep == mSteps.S3_ADD_FILTERS" (click)="stepSelected.emit(mSteps.S3_ADD_FILTERS)">
					<h4><em class="fa fa-filter" aria-hidden="true"></em> FILTERS</h4>
					
					<!-- Location -->
					<span *ngIf="mRule != null && (mRule.locations != null || mRule.zones != null)">
						<p><i class="fa fa-location-arrow" ></i> LOCATION</p>
					</span>
					
					<!-- Time -->
					<span *ngIf="mRule.days != null && mRule.startTime != null">
						<p><i class="fa fa-calendar" ></i> DAYS(S) AND TIME(S)</p>
					</span>				
					
					<span *ngIf="mRule.conditions != null">
						<ng-container *ngFor="let condition of mRule.conditions">
							<span *ngIf="condition.sourceType != mSourceTypes.EVENT" data-toggle="collapse">
								<p>{{condition.sourceType}}</p>
							</span>
						</ng-container>
					</span>
				</li>
						
				<!-- STEP 4 - CHOOSE REACTION(S) -->
				<li class="list-group-item rule-item" [class.active]="mStep == mSteps.S4_CHOOSE_REACTIONS"(click)="stepSelected.emit(mSteps.S4_CHOOSE_REACTIONS)">
					<h4><em class="fa fa-flask" aria-hidden="true"></em> REACTIONS</h4>
					<span *ngIf="mRule.actions != null && mRule.actions.length > 0">
						<ng-container *ngFor="let action of mRule.actions">
							<p><i class="fa {{getIconForActionInstance(action)}}"></i> {{action.action.name}}</p>
						</ng-container>
					</span>
				</li>
						
				<!-- STEP 5 - REVIEW & FINISH -->
				<li class="list-group-item rule-item" [class.active]="mStep == mSteps.S5_REVIEW_AND_FINISH" (click)="stepSelected.emit(mSteps.S5_REVIEW_AND_FINISH)">
					<h4><em class="fa fa-flag-checkered" aria-hidden="true"></em> REVIEW &amp; FINISH</h4>
				</li>
			</ul>
		</div>

		<div class="panel-footer">
			<!-- PAGE BUTTONS -->
			<ul class="pager wizard">
				<li *ngIf="mStep != mSteps.S1_SELECT_TRIGGER" class="previous">
					<a (click)="selectPreviousStepClicked()" style="cursor: pointer;">
						PREVIOUS
					</a>
				</li>
				<li *ngIf="mStep != mSteps.S5_REVIEW_AND_FINISH" class="next">
					<a (click)="selectNextStepClicked()" style="cursor: pointer;">
						NEXT
					</a>
				</li>
			</ul>
		</div>
	</div>
	<button
			class="btn btn-primary"
			style="position: relative; left:20px; bottom: auto; margin-bottom: 50px;"
			(click)="onCancelClicked()">
			<i class="fa fa-close"></i> 
				CANCEL
	</button>
</nav>